export default {
  "content": "<path d=\"M12 15a1.5 1.5 0 110 3.001 1.5 1.5 0 010-3zM12 5.75c2 0 3.5 1.53 3.5 3.46 0 .982-.404 1.808-1.072 2.386-.411.355-.902.6-1.428.746v.908h-2v-2.69l.938-.058c.528-.033.93-.202 1.182-.42.233-.201.38-.477.38-.872 0-.822-.6-1.46-1.5-1.46-.898 0-1.577.651-1.767 1.648l-1.965-.375C8.59 7.337 9.905 5.75 12 5.75z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.929 4.929c3.905-3.905 10.237-3.905 14.142 0 3.906 3.905 3.906 10.237 0 14.142-3.905 3.906-10.237 3.906-14.142 0-3.905-3.905-3.905-10.237 0-14.142zm12.728 1.414A8 8 0 106.343 17.658 8 8 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};